import { useTranslation } from "react-i18next";

import BagSvg from "@/assets/common/other_icons/bag.svg?react";

import BaseCard, { ActionButton } from "./BaseCard";

function CommunicationKit() {
  const { t } = useTranslation("communicate");

  return (
    <BaseCard
      Icon={BagSvg}
      title={t("communicationKit.title")}
      text={t("communicationKit.text")}
      orientation="vertical"
    >
      <ActionButton
        to="https://hellocarbo-25361575.hs-sites-eu1.com/knowledge/valoriser-votre-engagement#kit-de-communication"
        shouldOpenNewTab
      >
        {t("communicationKit.openKit")}
      </ActionButton>
    </BaseCard>
  );
}

export default CommunicationKit;
